import React, { type FunctionComponent } from 'react'
import { Text } from '@retailer-platform/shared-components'
import { FormattedNumber } from 'react-intl'

interface Props {
  priceCents?: string
}

export const ProductsSearchTablePriceCell: FunctionComponent<Props> = ({ priceCents }) => (
  <Text>{priceCents ? <FormattedNumber format="price" value={+priceCents / 100} /> : '-'}</Text>
)
